/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairOrderPreviewsResponse } from '../../models/finnair-order-previews-response';

export interface FetchOrderPreviews$Params {

/**
 * CAS authentication token in Bearer format. Takes priority over the Authorization header if both are present.
 */
  oauth_token?: any;
  locale?: string;
}

export function fetchOrderPreviews(http: HttpClient, rootUrl: string, params?: FetchOrderPreviews$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairOrderPreviewsResponse>> {
  const rb = new DapiRequestBuilder(rootUrl, fetchOrderPreviews.PATH, 'get');

  if (params) {
    rb.header('oauth_token', params.oauth_token, {});
    rb.query('locale', params.locale, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairOrderPreviewsResponse>;
    }),
    catchErrorAsJson()
  );
}

fetchOrderPreviews.PATH = '/api/v2/order-previews';
